<template>
  <div>
    <h2 class="text__center">{{ getActiveType.name }} Requests</h2>
    <Filters :namespace="getActiveType.namespace" :filters="getFilters"></Filters>
    <p class="flex__between flex__wrap">
      <span class="mr-10">Showing {{ shownRequests }} out of {{ countRequests }} requests</span>
      <ExportData :data="getExportData" :type="getActiveType.url" />
    </p>
    <div class="tile-group">
      <router-link
        v-for="request in requests"
        :key="request._id"
        class="tile tile--request link__none"
        :class="request.status"
        :to="`${getActiveType.url}/${request._id}`"
      >
        <p class="flex__between">
          <span class="text__bold mr-10">Name</span>
          <span class="text__overflow">{{ request.name }}</span>
        </p>
        <p class="flex__between">
          <span class="text__bold mr-10">Submitted</span>
          <span class="text__overflow">{{ formatDate(request.createdAt) }}</span>
        </p>
        <p class="flex__between">
          <span class="text__bold">Status</span>
          <span class="text__overflow">{{ request.status }}</span>
        </p>
        <button class="btn" @click="startSetActive(request._id)">See Request</button>
      </router-link>
    </div>
    <scroll-loader v-if="count < countRequests" :loader-method="showMore" :loader-color="'#4a773c'"></scroll-loader>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Filters from "./Filters";
import ExportData from "./ExportData";

export default {
  components: {
    Filters,
    ExportData
  },
  data() {
    return {
      count: 12
    };
  },
  computed: {
    ...mapGetters(["getActiveType"]),
    getFilters() {
      return this.$store.getters[`${this.getActiveType.namespace}/getFilters`];
    },
    getFilteredRequests() {
      return this.$store.getters[
        `${this.getActiveType.namespace}/getFilteredRequests`
      ];
    },
    getExportData() {
      return [...this.getFilteredRequests].map(request => {
        request.services = request.services.filter(service => {
          return service.active;
        });
        return request;
      });
    },
    requests() {
      return this.getFilteredRequests.slice(0, this.shownRequests);
    },
    countRequests() {
      return this.getFilteredRequests.length;
    },
    shownRequests() {
      if (this.count > this.countRequests) {
        return this.countRequests;
      } else {
        return this.count;
      }
    }
  },
  methods: {
    startSetActive(id) {
      this.$store.dispatch(
        `${this.getActiveType.namespace}/startSetActive`,
        id
      );
    },
    showMore() {
      // artificially delay loading more requests by half a second
      setTimeout(() => {
        if (this.count + 4 > this.countRequests) {
          this.count = this.countRequests;
        } else {
          this.count += 4;
        }
      }, 500);
    },
    formatDate(date) {
      return moment(date).format("MM-DD-YYYY");
    }
  }
};
</script>

<style scoped lang="scss">
</style>